/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit, change } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { RequestForm } from './components/request-form';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	createRequestAction,
	getCustomersAction,
	getAddressesAction,
	getDictionariesAction,
	getPartnersAction,
	getRequestInfoAction,
	resetStateAction,
	setRequestInfoAction,
	updateRequestAction,
	getTimezonesAction,
} from './actions';
import {
	getActiveRequestIdSelector,
	getCompanyIdSelector,
	getIsModalShownSelector,
	getIsRequestAddFormOpenSelector,
	getReqNameSelector,
	getRequestFormInitialValuesSelector,
	getRequestRouteSelector,
	getRouterQueriesSelector,
	getIsRequestInfoLoadingSelector,
	getIsAllOptionsListLoadingSelector,
	getIsRequestSavingSelector,
} from './selectors';
import { RequestPartnerModal } from './components/partner-form';
import { AddressModal } from './components/address-modal';
import { ContactModal } from './components/contact-modal';
import { REQUEST_FORM_NAME } from './constants';
import { RequestFormExpress } from './components/request-form-express';
import { RequestFormCar } from './components/request-form-car';
import { RequestFormAvia } from './components/request-form-avia';
import cancelModal from '../../utils/cancelModal';
import closeModal from '../../utils/closeModal';
import { CustomLoader } from '../../components/custom-loader';

const RequestModalWrapper = ({
	isRequestAddFormOpen,
	onGetCustomers,
	onGetPartners,
	onGetDictionaries,
	isModalShown,
	onResetState,
	onGetRequestInfo,
	activeRequestId,
	onFormSubmit,
	onUpdateRequest,
	reqName,
	onCreateRequest,
	onResetForm,
	initialValues,
	onSetRequestInfo,
	companyId,
	onGetAddresses,
	routerQueries,
	requestRoute,
	isRequestInfoLoading,
	isOptionsListLoading,
	isRequestSaving,
	onGetTimezones,
}) => {
	useInjectSaga({ key: 'requestFormSaga', saga });
	useInjectReducer({ key: 'requestFormReducer', reducer });
	const history = useHistory();

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const [isPartnerModalShow, setIsPartnerModalShow] = useState(false);

	const [isAddressModalShow, setIsAddressModalShow] = useState(false);

	const [isContactModalShow, setIsContactModalShow] = useState(false);

	useEffect(() => {
		if (!isModalShown) {
			setIsPartnerModalShow(false);
			setIsAddressModalShow(false);
			setIsContactModalShow(false);

			onResetState();
			onResetForm(REQUEST_FORM_NAME);
		}
	}, [isModalShown]);

	useEffect(() => {
		if (isModalShown) {
			onGetDictionaries();
			onGetCustomers();

			if (query.get('mode') === 'add') {
				onGetPartners();
			}
		}

		// on create add company creator id
		if (isModalShown && query.get('mode') === 'add') {
			const newPoints = [...(initialValues.points || [])];

			if (!initialValues?.points?.[0]?.partner) {
				newPoints[0] = {
					...(initialValues.points?.[0] || {}),
					partner: {
						id: companyId,
					},
				};

				initialValues = { ...initialValues, is_unchanged_fetch_at: true };

				onGetAddresses({ id: companyId, index: 0 });
			}

			if (!initialValues?.points?.[1]) {
				newPoints[1] = {};
			}

			if (!initialValues?.customer_id) {
				initialValues = { ...initialValues, customer_id: companyId };
			}

			onSetRequestInfo({ ...initialValues, points: newPoints });
		}

		if (isModalShown && activeRequestId && (isEmpty(initialValues) || !initialValues?.id)) {
			onGetRequestInfo({ id: activeRequestId, mode: query.get('mode') });
		}
	}, [isModalShown]);

	useEffect(() => {
		if (isAddressModalShow) {
			onGetTimezones();
		}
	}, [isAddressModalShow]);

	const handleModalCancel = async () => {
		cancelModal(query);
		onResetState();
		onResetForm(REQUEST_FORM_NAME);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = async () => {
		closeModal(query);
		onResetState();
		onResetForm(REQUEST_FORM_NAME);
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(REQUEST_FORM_NAME);

		const path = pathname.includes('reqs') ? pathname : requestRoute;

		const route = path.split('/').slice(0, 3).join('/');

		if (activeRequestId) {
			const { mode } = routerQueries;
			if (mode === 'recreate') {
				onCreateRequest({
					searchQuery: query,
					redirect: handleModalClose,
					pathname: route,
					mode: 'recreate',
				});
			} else {
				onUpdateRequest({
					id: activeRequestId,
					searchQuery: query,
					redirect: handleModalClose,
					pathname: route,
				});
			}
		} else {
			onCreateRequest({ searchQuery: query, redirect: handleModalClose, pathname: route });
		}
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	if (isModalShown) {
		if (isPartnerModalShow) {
			return (
				<RequestPartnerModal
					onSetIsModalShow={setIsPartnerModalShow}
					onSetIsAddressModalShow={setIsAddressModalShow}
				/>
			);
		}

		if (isAddressModalShow) {
			return (
				<AddressModal
					onSetIsModalShow={setIsAddressModalShow}
					onSetIsContactModalShow={setIsContactModalShow}
				/>
			);
		}

		if (isContactModalShow) {
			return <ContactModal onSetIsModalShow={setIsContactModalShow} />;
		}
	}

	// change form depends on page
	let form = <CustomLoader />;
	let title = '';

	const routePath = requestRoute || pathname;

	const formConfig = {
		combined: {
			form: (
				<RequestForm
					onSetIsPartnerModalShow={setIsPartnerModalShow}
					onSetIsAddressModalShow={setIsAddressModalShow}
					onSetIsContactModalShow={setIsContactModalShow}
				/>
			),
			title: '<span class="divide">LTL-перевозки</span>',
		},
		car: {
			form: (
				<RequestFormCar
					onSetIsPartnerModalShow={setIsPartnerModalShow}
					onSetIsAddressModalShow={setIsAddressModalShow}
					onSetIsContactModalShow={setIsContactModalShow}
				/>
			),
			title: '<span class="divide">FTL-перевозки</span>',
		},
		express: {
			form: (
				<RequestFormExpress
					onSetIsPartnerModalShow={setIsPartnerModalShow}
					onSetIsAddressModalShow={setIsAddressModalShow}
					onSetIsContactModalShow={setIsContactModalShow}
				/>
			),
			title: '<span class="divide">Развоз по территории</span>',
		},
		avia: {
			form: (
				<RequestFormAvia
					onSetIsPartnerModalShow={setIsPartnerModalShow}
					onSetIsAddressModalShow={setIsAddressModalShow}
					onSetIsContactModalShow={setIsContactModalShow}
				/>
			),
			title: '<span class="divide">Авиа заявка</span>',
		},
	};

	const formType = Object.keys(formConfig).find(type => routePath.includes(type));

	if (formType) {
		form = formConfig[formType].form;
		title = formConfig[formType].title;
	}

	const addButtons = [
		{
			onClick: handleFormSubmit,
			text: 'Добавить',
			color: 'primary',
			loading: isRequestSaving,
			disabled: isOptionsListLoading || isRequestInfoLoading || isRequestSaving,
		},
		{ onClick: handleModalCancel, text: 'Отмена', color: 'secondary', disabled: isRequestSaving },
	];

	const saveButtons = [
		{
			onClick: handleFormSubmit,
			text: 'Сохранить',
			color: 'primary',
			loading: isRequestSaving,
			disabled: isOptionsListLoading || isRequestInfoLoading || isRequestSaving,
		},
		{
			onClick: handleModalCancel,
			text: 'Отмена',
			color: 'secondary',
			disabled: isRequestSaving,
		},
	];

	let headerText = title;
	let buttons = addButtons;

	if (!isRequestAddFormOpen) {
		headerText = reqName;
		buttons = saveButtons;
		if (query.get('mode') === 'recreate') {
			headerText = title;
			buttons = addButtons;
		}
	}

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText={headerText}
			modalContent={form}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'request' }]}
			footerButtons={<ModalFooterButtons rightButtons={buttons} />}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isOptionsListLoading: getIsAllOptionsListLoadingSelector(),
	isModalShown: getIsModalShownSelector(),
	routerQueries: getRouterQueriesSelector(),
	activeRequestId: getActiveRequestIdSelector(),
	isRequestAddFormOpen: getIsRequestAddFormOpenSelector(),
	reqName: getReqNameSelector(),
	initialValues: getRequestFormInitialValuesSelector(),
	companyId: getCompanyIdSelector(),
	requestRoute: getRequestRouteSelector(),
	isRequestInfoLoading: getIsRequestInfoLoadingSelector(),
	isRequestSaving: getIsRequestSavingSelector(),
});

const mapDispatchToProps = {
	onGetCustomers: getCustomersAction,
	onGetPartners: getPartnersAction,
	onGetDictionaries: getDictionariesAction,
	onResetState: resetStateAction,
	onGetRequestInfo: getRequestInfoAction,
	onFormSubmit: submit,
	onUpdateRequest: updateRequestAction,
	onCreateRequest: createRequestAction,
	onResetForm: reset,
	onSetRequestInfo: setRequestInfoAction,
	onGetAddresses: getAddressesAction,
	onFieldChange: change,
	onGetTimezones: getTimezonesAction,
};

RequestModalWrapper.propTypes = {
	isOptionsListLoading: PropTypes.bool.isRequired,
	isRequestAddFormOpen: PropTypes.bool,
	onGetCustomers: PropTypes.func.isRequired,
	onGetPartners: PropTypes.func.isRequired,
	onGetDictionaries: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	onResetState: PropTypes.func.isRequired,
	onGetRequestInfo: PropTypes.func.isRequired,
	activeRequestId: PropTypes.string,
	onFormSubmit: PropTypes.func.isRequired,
	onUpdateRequest: PropTypes.func.isRequired,
	reqName: PropTypes.string.isRequired,
	onCreateRequest: PropTypes.func.isRequired,
	onResetForm: PropTypes.func.isRequired,
	initialValues: PropTypes.object.isRequired,
	onSetRequestInfo: PropTypes.func.isRequired,
	companyId: PropTypes.number,
	onGetAddresses: PropTypes.func.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	isRequestInfoLoading: PropTypes.bool.isRequired,
	routerQueries: PropTypes.object,
	requestRoute: PropTypes.string,
	isRequestSaving: PropTypes.bool,
	onGetTimezones: PropTypes.func.isRequired,
};

const RequestModal = connect(mapStateToProps, mapDispatchToProps)(RequestModalWrapper);

export default RequestModal;
